import React from 'react';
import SelectInput from '@/se/components/inputs/SelectInput';
import { PhysicianCategory, PhysicianCategoryLabels } from '../../entities/physician/enums';

/**
 * Category Select - dropdown version of CategoryPicker.
 *
 * Replaces the horizontal tabs with a compact dropdown select,
 * saving vertical space and fitting better in the filter row.
 *
 * This component is reusable across different views that need category filtering.
 */
const CategorySelect: React.FC<{
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}> = ({ value, onChange }) => {
  const categories = Object.keys(PhysicianCategory);

  // Build options object with "All" as first option
  const options: Record<string, string> = {
    '': 'All Categories',
    ...categories.reduce(
      (acc, cat) => ({
        ...acc,
        [cat]: PhysicianCategoryLabels[cat as keyof typeof PhysicianCategoryLabels],
      }),
      {}
    ),
  };

  const handleChange = (newValue: string) => {
    onChange(newValue || undefined);
  };

  return (
    <SelectInput
      placeholder="Category"
      options={options}
      value={value || ''}
      onChange={handleChange}
      isSearchable={false}
      menuWidthFollowContent={false}
      name="category"
    />
  );
};

export default CategorySelect;
